// Shared status -> color/label mapping used across the Societies & Compliance panel.
export const STATUS_COLORS = {
  complete: '#2e7d32',
  pending: '#ed6c02',
  expired: '#d32f2f'
}

export const STATUS_LABEL_KEYS = {
  complete: 'Complete',
  pending: 'Pending',
  expired: 'Expired'
}

export function getStatusColor(status) {
  return STATUS_COLORS[status] || STATUS_COLORS.pending
}
